import { ɵɵtrustConstantResourceUrl } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function postalEspanolSenseCeutaMelillaValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) return null;

    // Comprovar format 5 dígits
    const regex = /^[0-9]{5}$/;
    if (!regex.test(value)) {
      return { postalInvalid: 'El codi postal ha de tenir 5 dígits' };
    }

    const prefix = Number(value.substring(0, 2));
    const cpFull = Number(value);

    // Excloure Ceuta (510xx) i Melilla (520xx)
    if (
      (prefix === 51 && cpFull >= 51001 && cpFull <= 51005) ||
      (prefix === 52 && cpFull >= 52001 && cpFull <= 52006)
    ) {
      control.setErrors({ exclouCeutaMelilla: true });
      return { exclouCeutaMelilla: true };
    }

    return null;
  };
}
